<div class="modal-header">
    Fattura elettronica
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close()" >
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body text-center">
     <div class="row mb-1" *ngIf="id_type==1 && role_pa && (sdi_status==0 || sdi_status==-1 || sdi_status==3)">
        <div class="col-12">
            <i class="float-left h-100 pr-2 text-info fas fa-info-circle fa-2x"></i>
            <div class="float-left text-left">
                <small>
                    Il cessionario/committente è una <b>Pubblica Amministrazione</b>, per cui è necessario inviare la fattura elettronica firmata digitalmente allo SdI.<br>
                    Scarica il file XML e firmalo. Poi cliccare su <b>Invia file firmato</b>.
                </small>
            </div>
        </div>
    </div>    
    <div class="row mb-1" *ngIf="id_type==1 && message.length>0">
        <div class="col-12">
            <i class="float-left h-100 pr-2 text-warning fas fa-exclamation-triangle fa-2x"></i>
            <div class="float-left text-left">
                <small>
                    <b>ATTENZIONE:</b><br>
                    Il Sistema ha evidenziati i seguenti errori:
                    <div *ngFor="let m of message"><span class="text-red">&#10008;</span> {{m.message.substring(36)}}</div>
                </small>
            </div>
        </div>
    </div>   
    <div class="row mt-3">        
        <!-- <div class="col-lg-3 text-lg-right">
            <label>Visualizza</label>
        </div> -->
        <div class="col-lg-12">
            <div class="btn-group btn-group-sm w-100">
                <button type="button" class="btn btn-default border btn-sm" 
                    [class.br-primary]="style==style1" 
                    (click)="updateStyle(style1)">Formato Ministeriale
                </button>
                <button type="button" class="btn btn-default border btn-sm" 
                    [class.bg-primary]="style==style2"
                    (click)="updateStyle(style2)">Formato Assosoftware
                </button>
            </div>
        </div>
    </div>
    <hr>   
    <iframe id="frame"
            [src]="sanitizer.bypassSecurityTrustResourceUrl(url)"
            [frameBorder]="0"
            [class.style1]="style==style1" 
            [class.style2]="style==style2" 
            ></iframe>
</div>
<div class="modal-footer">
    <ng-container *ngIf="id_type==1">
        <ng-container *ngIf="sdi_status==0 || sdi_status==-1 || sdi_status==3">
            <ng-container *ngIf="role_pa">
                <a type="button" [disabled]="message.length>0" class="btn btn-outline-success" (click)="uploadXML()" ><i class="far fa-paper-plane mr-2"></i>Invia file firmato</a>
            </ng-container>
            <ng-container *ngIf="!role_pa">
                <a type="button" [disabled]="message.length>0" class="btn btn-outline-success" (click)="sendToSdi()" ><i class="far fa-paper-plane mr-2"></i>Invia allo SdI</a>
            </ng-container>
            
        </ng-container>    
        <a *ngIf="url_xml && url_xml.substr(-3)=='xml'" href="{{url_xml}}" target="_blank" class="btn btn-outline-primary" (click)="close()">
            <i class="fas fa-file-download mr-2"></i>Scarica file XML
            <!-- <span *ngIf="message.length>0"> comunque</span> -->
        </a>
    </ng-container>
    <a type="button"  class="btn btn-outline-primary" (click)="downloadPreview()" ><i class="fas fa-print mr-2"></i>Anteprima di stampa</a>
    <a type="button" (click)="close()" class="btn btn-outline-secondary"><i class="fas fa-times mr-1"></i>Chiudi</a>
</div>


<ng-template #uploadXMLModal let-modal>
    <div class="modal-body">
        <div class="form-group text-center">
            <div class="mb-2">
                <label>Inserisci il file XML firmato da inviare al Sistema di Interscambio.</label>
            </div>
            <div class="m-auto text-center p-2" style="width:90%; height:200px; color:#ccc; border: 1px dashed #ccc; border-radius:10px">
                <i class="fas fa-2x fa-bullseye mt-5"></i><br>
                <i>Trascina e rilascia <b>qui</b>.</i><br>
                <a class="btn btn-outline-primary btn-sm mt-4" (click)="fileToUpload.click()"><i class="fas fa-upload mr-2"></i>Carica file</a>
            </div>
            <input class="pointer d-block" style="opacity:0;width:90%;height:200px;margin:-200px auto 0;" type="file" #fileToUpload name="fileXMLToUpload" (change)="handleFileXMLInput($event.target.files);confirmUploadXMLModal();">
        </div>
        <button class="btn btn-outline-secondary float-right" (click)="closeUploadXMLModal();">Annulla</button>
    </div>
</ng-template>